export default __webpack_public_path__ + "static/media/typebicycle.6f7881ed.svg";